<template>
  <div class="capacityPickupBox">
    <Loading v-if="loading" />
    <div class="capacityPickupBox__header">
      <Link :title="$t('backToInfoPickupBox')" @back-to="backTo" />
      <div class="block-title">
        <Title :title="$t('capacity')" />
        <Title :title="capacityPickupBoxIdResult.name" />
        <Title :title="capacityPickupBoxIdResult.id" />
      </div>
      <Dropdown
        class="capacityPickupBox__header-dropdown"
        :selected-option="getOption.selectedOption"
        :options="getOption.options"
        @select-option="changeItem"
      />
      <div class="block-input">
        <InputCapacity
          v-model="averagePickupTime"
          type="number"
          name="averagePickupTime"
          :label="$t('averagePickupTime')"
          disabled
        />
        <span>
          {{ $t('Hours') }}
        </span>
      </div>
    </div>
    <Table :data="capacityPickupBoxType" :columns="columns" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import router from '@/router';
import moment from 'moment';

import Loading from '@/views/Loading.vue';
import InputCapacity from './InputCapacity/InputCapacity.vue';

import { activeOptions, columns } from './configs';
import { Option } from '@/types';

@Options({
  name: 'CapacityPickupBox',
  components: {
    Loading,
    InputCapacity
  },
  data() {
    return {
      loading: false,
      columns: columns(this.$t),
      getOption: {
        selectedOption: {
          value: 'week',
          label: this.$t('week')
        },
        options: activeOptions(this.$t)
      },
      averagePickupTime: null
    };
  },
  computed: {
    ...mapState('pharmacy', [
      'capacity',
      'capacityPickupBoxIdResult',
      'capacityPickupBoxType'
    ])
  },
  created() {
    this.show();
  },
  methods: {
    ...mapActions('pharmacy', [
      'getPickupBoxCapacity',
      'getCapacityByPickupBoxId'
    ]),
    async show() {
      this.loading = true;
      const { boxId } = this.$route.params;

      const defaultParams = {
        boxId: boxId,
        startTime: moment().subtract(7, 'd').valueOf(),
        endTime: moment().valueOf(),
        ...this.params
      };

      await this.getCapacityByPickupBoxId(defaultParams);
      this.averagePickupTime = this.capacityPickupBoxIdResult.averagePickupTime;

      this.loading = false;
    },
    backTo() {
      const { id } = this.$route.params;
      router.push({ name: 'InfoPickupBox', params: { id } });
    },
    changeItem(option: Option) {
      this.getOption.selectedOption = option;
    }
  },
  watch: {
    'getOption.selectedOption': {
      handler() {
        const dateValue = this.getOption.selectedOption.value;

        if (dateValue === 'week') {
          this.params = {
            ...this.params,
            startTime: moment().subtract(7, 'd').valueOf()
          };

          this.show();
        }

        if (dateValue === 'month') {
          this.params = {
            ...this.params,
            startTime: moment().subtract(1, 'months').valueOf()
          };
          this.show();
        }
      }
    }
  }
})
export default class CapacityPickupBox extends Vue {}
</script>

<style lang="scss" scoped>
.capacityPickupBox {
  padding: 20px;
  .capacityPickupBox__header {
    margin-bottom: 16px;
    .block-title {
      display: flex;
      column-gap: 15px;
    }
    .link {
      margin-bottom: 27px;
    }
    .capacityPickupBox__header-dropdown {
      margin: 24px 0;
      height: 40px;
      width: 288px !important;
    }
    .block-input {
      position: relative;
      width: max-content;
      span {
        position: absolute;
        top: 18px;
        right: 18px;
        color: $label;
        font-weight: 400;
        font-size: $fourteenSize;
        line-height: $fourteenSize;
      }
    }
  }
}
</style>
